import React, { useEffect, useState } from 'react';
import { Dropdown } from "react-bootstrap";
import { BsFillGrid1X2Fill } from "react-icons/bs";
import { FaUser } from "react-icons/fa6";
import { Link, useNavigate } from 'react-router-dom';
import { RxHamburgerMenu } from "react-icons/rx";
import MobileSidebarLinks from '../Components/OffcanvasMenu/MobileSidebarLinks';
import ResizeHook from '../Components/Hooks/ResizeHook';
import Logo from "../assets/img/logo.png";
import { logout } from '../actions/users';
import { deleteToken } from '../actions/commonFunction';
import config from '../lib/config';
import { Log_Out } from '../actions/redux/action';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const Header = () => {
  
  
  const navigate = useNavigate();
  const dispatch = useDispatch();


  // const [rewidth, setRewidth] = useState(window.innerWidth);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const widthResize = ResizeHook();


  // useEffect(() => {
  //   const handleResize = () => {
  //     setRewidth(window.innerWidth);
  //   }
  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   }
  // }, [rewidth]);

  const logoutuser = () => {
    let confirm = window.confirm("Do you want to sign out?")
    if (confirm) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem(config.adminWalletAddressKey);
      deleteToken(config.adminCookieName);
      dispatch({
        type: Log_Out,
      })
      navigate("/")
    }
    else {
      toast.error("Cancelled Logout");
    }
  }

  return (
    <>
      <header className="header">
        <div className="headerbox">
          {
            widthResize > 991 ?
              <div>
                <p className="headerbox_head pe-4">Admin</p>
                {/* <div className="headerbox_icon"><BsFillGrid1X2Fill /></div> */}
                <Dropdown className="headerbox_drop">
                  <Dropdown.Toggle><FaUser /></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link to="/user" className="dropdown-item">Profile</Link>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      className='dropdown-item'
                      onClick={()=>logoutuser()}
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> :
              <div className="d-flex align-items-center justify-content-between">
                <Link to="/dashboard">
                  <img src={Logo} alt="Edaface" className="img-fluid logo" />
                </Link>
                <button type="button" className="btn mobtoggle" onClick={handleShow}>
                  <RxHamburgerMenu />
                </button>
              </div>
          }
        </div>
      </header>
      <MobileSidebarLinks show={show} handleClose={handleClose} />
    </>
  )
}

export default Header;